<template>
  <form
    @submit.prevent.stop=""
    v-if="l">
    <tabs
      :level="1"
      :is-fullwidth="true"
      :links="lotFormTabsLinks"
      :current-tab="lotFormTab"
      @changeView="lotFormTab = $event"
      mode="emitter"
      class="is-border-bottom"></tabs>
    <div class="has-background-notification is-padding-left is-padding-right">
      <div class="is-size-6 has-text-white is-padding-top-xxsmall is-padding-bottom-xxsmall">
        <span class="icon is-small is-size-7 is-margin-right-xxsmall">
          <i class="fas fa-check-circle"></i>
        </span>
        <i>Information obligatoire pour la validation du formulaire</i>
      </div>
    </div>
    <div v-show="lotFormTab === 'FICHE_LOT'">
      <div class="has-background-light">
        <div class="is-padding-left is-padding-right is-padding-top">
          <div class="title is-5 is-uppercase">
            <b>Caractéristiques du lot</b>
          </div>
        </div>
      </div>
      <div class="has-background-light is-padding">
        <div class="columns is-multiline">
          <div class="column is-6">
            <r-label
              label="Nature"
              :red-check="hasCheck"
              :value="lot.nature"></r-label>
            <div class="control">
              <div class="select is-fullwidth">
                <select
                  v-model="lot.nature"
                  id="nature">
                  <option :value="null">
                    Selectionnez une nature
                  </option>
                  <option
                    v-for="c in filteredNaturesList"
                    :value="c.value"
                    :key="c.value"
                    :id="c.value">
                    {{ c.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div
            class="column is-6">
            <r-label
              label="Typologie"
              :is-required="['flat', 'house', 'parking', 'annexe'].includes(lot.nature)"
              :red-check="hasCheck"
              :value="lot.lot_type"></r-label>
            <div class="control">
              <div class="select is-fullwidth">
                <select
                  v-model="lot.lot_type"
                  id="lot_type">
                  <option :value="null">
                    Selectionnez un type
                  </option>
                  <option
                    v-for="(c, i) in filteredTypesList"
                    :value="c.value"
                    :key="i"
                    :id="c.value">
                    {{ c.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div
            class="column is-6"
            v-if="lot.nature == 'field'">
            <r-label
              label="Nombre de face"
              :is-required="false"
              :value="lot.nb_face"></r-label>
            <div class="control">
              <div class="select is-fullwidth">
                <select
                  v-model="lot.nb_face"
                  id="lot_type">
                  <option :value="null">
                    Selectionnez un type
                  </option>
                  <option
                    v-for="(c, i) in filteredNbFaceList"
                    :value="c.value"
                    :key="i"
                    :id="c.value">
                    {{ c.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div
            class="column is-6">
            <r-label
              label="Mode de vente"
              :is-required="false"
              :value="lot.sales_mode"></r-label>
            <div class="control">
              <multiselect
                v-model="lot.sales_mode"
                :options="filteredSalesModeList"
                class="multiselect--option-ico"
                :multiple="true"
                :close-on-select="false"
                :placeholder="''"
                track-by="value"
                label="label">
                <span
                  slot="placeholder"
                  class="multiselect__placeholder">Selectionner un type</span>
                <span slot="noOptions">La liste est vide</span>
              </multiselect>
            </div>
          </div>
          <div
            class="column is-6">
            <r-label
              label="Equivalent Lots"
              :is-required="false"
              :value="lot.equivalent"></r-label>
            <div class="control">
              <v-input
                id="equivalent"
                name="equivalent"
                @input="lot.equivalent = $event"
                :model="roundedValue(lot.equivalent)"
                :number="true"
                :three-space="true"
                v-validate="'required|decimal:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Equivalent"
                min="1">
              </v-input>
            </div>
          </div>
          <div class="column is-6">
            <r-label
              label=""
              :is-required="false"></r-label>
            <div class="control">
              <div class="columns is-gapless is-multiline has-cloud-checkradiocase">
                <div
                  class="column is-3 has-background-white"
                  v-for="e in filteredSubtypesList"
                  :key="'subtype-' + e.value">
                  <input
                    v-model="lot.lot_subtype"
                    :value="e.value"
                    name="subtypes"
                    :id="'subtype-' + e.value"
                    type="checkbox"
                    class="vadCheckradiocase is-fullwidth">
                  <label :for="'subtype-' + e.value">{{ e.label }}</label>
                </div>
              </div>
            </div>
          </div>
          <div
            class="column is-3"
            v-if="!['field', 'garden'].includes(lot.nature)">
            <r-label
              label="Étage"
              :is-required="lot.nature === 'parking' ? false : hasCheck"
              :red-check="hasCheck"
              :value="lot.floor"></r-label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="lot.floor">
                  <option :value="null">
                    Selectionnez l'étage du lot
                  </option>
                  <option
                    v-for="c in floorsList"
                    :value="c.value"
                    :key="c.value">
                    {{ c.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div
            class="column is-3"
            v-if="lot.nature !== 'parking'">
            <r-label
              label="Surface en m2"
              :value="lot.surface"
              :red-check="hasCheck"></r-label>
            <div class="control">
              <v-input
                id="surface"
                name="surface"
                @input="lot.surface = $event"
                :model="roundedValue(lot.surface)"
                input-type="number"
                :number="true"
                :three-space="true"
                v-validate="'required|decimal:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Surface">
              </v-input>
            </div>
          </div>
          <div
            v-if="lot.nature === 'field'"
            class="column is-3">
            <r-label
              label="Surface plancher en m2"
              :is-required="false"
              :value="lot.floor_area"
              :red-check="false"></r-label>
            <div class="control">
              <v-input
                id="floor_area"
                name="floor_area"
                @input="lot.floor_area = $event"
                :model="lot.floor_area"
                input-type="number"
                :number="true"
                :three-space="true"
                v-validate="'decimal:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Surface plancher">
              </v-input>
            </div>
          </div>
          <div
            v-if="lot.nature === 'field'"
            class="column is-3">
            <r-label
              label="Dont surface inconstructible"
              :is-required="false"
              :value="lot.unbuildable_area"
              :red-check="false"></r-label>
            <div class="control">
              <v-input
                id="unbuildable_area"
                name="unbuildable_area"
                @input="lot.unbuildable_area = $event"
                :model="lot.unbuildable_area"
                input-type="number"
                :number="true"
                :three-space="true"
                v-validate="'decimal:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Dont surface inconstructible">
              </v-input>
            </div>
          </div>
          <div
            v-if="lot.nature === 'field'"
            class="column is-3">
            <r-label
              label="Emprise au sol en m2"
              :is-required="false"
              :value="lot.footprint"
              :red-check="false"></r-label>
            <div class="control">
              <v-input
                id="footprint"
                name="footprint"
                @input="lot.footprint = $event"
                :model="lot.footprint"
                input-type="number"
                :number="true"
                :three-space="true"
                v-validate="'decimal:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Emprise au sol">
              </v-input>
            </div>
          </div>
          <div
            v-if="lot.nature === 'field'"
            class="column is-3">
            <r-label
              label="Zone constructible en m2"
              :is-required="false"
              :value="lot.buildable_area"
              :red-check="false"></r-label>
            <div class="control">
              <v-input
                id="buildable_area"
                name="buildable_area"
                @input="lot.buildable_area = $event"
                :model="lot.buildable_area"
                input-type="number"
                :number="true"
                :three-space="true"
                v-validate="'decimal:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Zone constructible">
              </v-input>
            </div>
          </div>
          <div
            v-if="lot.nature === 'field'"
            class="column is-3">
            <r-label
              label="Surface imperméabilisée en m2"
              :is-required="false"
              :value="lot.waterproofed_surface"
              :red-check="false"></r-label>
            <div class="control">
              <v-input
                id="waterproofed_surface"
                name="waterproofed_surface"
                @input="lot.waterproofed_surface = $event"
                :model="lot.waterproofed_surface"
                input-type="number"
                :number="true"
                :three-space="true"
                v-validate="'decimal:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Surface imperméabilisée">
              </v-input>
            </div>
          </div>
          <div
            v-if="lot.nature === 'field'"
            class="column is-3">
            <r-label
              label="Référence cadastrale"
              :is-required="false"
              :value="lot.cadastral_reference"
              :red-check="false"></r-label>
            <div class="control">
              <v-input
                id="cadastral_reference"
                name="cadastral_reference"
                @input="lot.cadastral_reference = $event"
                :model="lot.cadastral_reference"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Référence cadastrale">
              </v-input>
            </div>
          </div>
          <div
            v-if="lot.nature === 'field'"
            class="column is-3">
            <r-label
              label="Façade constructible"
              :is-required="false"
              :value="lot.building_facade"
              :red-check="false"></r-label>
            <div class="control">
              <v-input
                id="building_facade"
                name="building_facade"
                @input="lot.building_facade = $event"
                :model="lot.building_facade"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Façade constructible">
              </v-input>
            </div>
          </div>
          <div
            class="column is-6"
            v-if="buildingsByTranche.length">
            <r-label
              v-if="!['field'].includes(lot.nature)"
              label="Bâtiment"
              :value="lot.building"
              :is-required="false"></r-label>
            <r-label
              v-else
              label="Sous-tranche"
              :value="lot.building"
              :is-required="false"></r-label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="lot.building">
                  <option :value="null">
                    Selectionnez le bâtiment du lot
                  </option>
                  <optgroup
                    v-for="tranche of buildingsByTranche"
                    :value="tranche.pk"
                    :key="tranche.pk"
                    :label="tranche.name">
                    <option
                      v-for="building in tranche.buildings"
                      :value="building.pk"
                      :key="building.pk">
                      {{ building.name }}
                    </option>
                  </optgroup>
                </select>
              </div>
            </div>
          </div>
          <div
            class="column is-6"
            v-else-if="lot.nature !== 'field' && programBuildings && programBuildings.length">
            <r-label
              label="Bâtiment"
              :value="lot.building"
              :is-required="false"></r-label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="lot.building">
                  <option :value="null">
                    Selectionnez le bâtiment du lot
                  </option>
                  <option
                    v-for="c in programBuildings"
                    :value="c.pk"
                    :key="c.pk">
                    {{ c.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="column is-12">
            <r-label
              label="Orientation"
              :is-required="false"></r-label>
            <div class="control">
              <div class="columns is-gapless is-multiline has-cloud-checkradiocase">
                <div
                  class="column is-3 has-background-white"
                  v-for="e in exposureList"
                  :key="'exposure-' + e.value">
                  <input
                    v-model="lot.exposures"
                    :value="e.value"
                    name="exposures"
                    :id="'exposure-' + e.value"
                    type="checkbox"
                    class="vadCheckradiocase is-fullwidth">
                  <label :for="'exposure-' + e.value">{{ e.label }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="has-background-white-bis is-padding-top is-padding-right is-padding-left">
        <div class="title is-5 is-uppercase">
          <b>Informations lot</b>
        </div>
      </div>
      <div class="has-background-white-bis is-padding">
        <div class="columns is-multiline">
          <div class="column is-6">
            <r-label
              label="Référence"
              :value="lot.ref"
              :red-check="hasCheck"></r-label>
            <div class="control">
              <v-input
                id="ref"
                name="ref"
                @input="lot.ref = $event"
                :model="lot.ref"
                :errors-bag="errors"
                v-validate="'required|min:2|max:20'"
                data-vv-value-path="val"
                data-vv-as="Référence">
              </v-input>
            </div>
            <p
              v-if="!lotRefAvailable"
              class="help is-danger">
              La référence existe déjà
            </p>
          </div>
          <div class="column is-6">
            <r-label
              label="Dispositifs"
              :value="lot.tax_dispositifs"
              :is-required="false"></r-label>
            <div class="control">
              <multiselect
                v-model="lot.tax_dispositifs"
                :options="filteredTypesTaxList"
                class="multiselect--option-ico"
                :multiple="true"
                :close-on-select="false"
                :placeholder="''"
                track-by="value"
                label="label">
                <span
                  slot="placeholder"
                  class="multiselect__placeholder">Dispositifs</span>
                <span slot="noOptions">La liste est vide</span>
              </multiselect>
            </div>
          </div>
          <!-- Price ht & ttc -->
          <div class="column is-6">
            <r-label
              :label="'Prix HT'"
              :red-check="true"
              :value="lot.sale_price_ht"
              class=""></r-label>
            <div class="field has-addons">
              <p class="control is-expanded">
                <v-input
                  id="sale_price_ht"
                  :name="'sale_price_ht'"
                  @input="val => updateSalePriceHt(val)"
                  :model="lot.sale_price_ht"
                  :number="true"
                  :disabled="!(isPromoteur && isAdmin)"
                  input-type="number"
                  :three-space="true"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  :classes-input="[!(isPromoteur && isAdmin) ? 'has-text-dark' : '']"
                  data-vv-as=" "
                  v-validate="'required|decimal:2'">
                </v-input>
              </p>
              <div class="control">
                <a class="button is-static is-border is-square"><b class="">€&nbsp;HT</b></a>
              </div>
            </div>
          </div>
          <div class="column is-2">
            <div class="field">
              <r-label
                :red-check="false"
                :label="'Tva'"
                :value="lot.tva"
                :truncate="false"
                class=""></r-label>
              <div class="control">
                <div class="select">
                  <select
                    class="has-text-weight-medium"
                    v-model="lot.tva"
                    @change="updateTva(lot.tva, lot.sale_price_ttc, null)"
                    :disabled="!(isPromoteur && isAdmin)">
                    <option
                      v-for="(tvaVal, idx) in tvaList"
                      :value="tvaVal"
                      :key="tvaVal + '-' + idx">
                      <span v-if="tvaVal !== 'autre'">{{ tvaVal | tvaLabelRounded }}%</span>
                      <span v-else>{{ tvaVal }}</span>
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column columns is-gapless is-space-around is-marginless is-padding-left is-padding-bottom-xlarge">
            <div class="column">
              <r-label
                :is-required="false"
                :label="'TVA sur marge'"
                :value="lot.tva_on_marge"
                :truncate="false"
                class=""></r-label>
              <div>
                <input
                  id="tvaOnMarge"
                  type="checkbox"
                  name="tvaOnMarge"
                  class="switch is-success is-success is-rounded is-large"
                  v-model="lot.tva_on_marge">
                <label
                  for="tvaOnMarge"
                  class="is-paddingless-top">
                </label>
              </div>
            </div>
            <div
              v-if="lot.tva_on_marge"
              class="column">
              <r-label
                :is-required="false"
                :label="'TVA réduite'"
                :value="lot.tva_reduce"
                :truncate="false"
                class=""></r-label>
              <div>
                <input
                  id="tvaReduce"
                  type="checkbox"
                  name="tvaReduce"
                  class="switch is-success is-success is-rounded is-large"
                  v-model="lot.tva_reduce">
                <label
                  for="tvaReduce"
                  class="is-paddingless-top">
                </label>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <r-label
              :label="'Prix TTC'"
              :red-check="true"
              :value="lot.sale_price_ttc"
              class=""></r-label>
            <div class="field has-addons">
              <p class="control is-expanded">
                <v-input
                  id="sale_price_ttc"
                  :name="'sale_price_ttc'"
                  input-type="number"
                  :number="true"
                  :three-space="true"
                  @input="val => updateSalePrice(val)"
                  :disabled="!(isPromoteur && isAdmin)"
                  :model="lot.sale_price_ttc"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  :classes-input="[!(isPromoteur && isAdmin) ? 'has-text-dark' : '']"
                  data-vv-as=" "
                  v-validate="'required|decimal:2'">
                </v-input>
              </p>
              <div class="control">
                <a class="button is-static is-border is-square"><b class="">€&nbsp;TTC</b></a>
              </div>
            </div>
          </div>
          <div
            class="column is-6">
            <div
              class="field"
              v-if="lot.tva">
              <r-label
                :is-required="false"
                label="Tva"
                :value="lot.tva"
                :truncate="false"></r-label>
              <div class="control">
                <v-input
                  :has-addons="true"
                  id="tva"
                  name="tva"
                  :model="lot.tva"
                  input-type="number"
                  v-validate="''"
                  :disabled="true"
                  :errors-bag="errors"
                  data-vv-value-path="val">
                  <p
                    class="control"
                    slot="addonRight">
                    <a class="button is-grey is-square is-static">
                      <span class="icon"><i class="fas fa-percentage"></i></span>
                    </a>
                  </p>
                </v-input>
              </div>
            </div>
            <div
              class="has-text-weight-light is-size-6"
              v-if="tvaAmount">
              ({{ tvaAmount | prettyPrice }} €)
            </div>
          </div>
          <div class="column is-6">
            <r-label
              :label="'Prix de création du lot'"
              :value="lot.created_price_ttc"
              :is-required="false"
              class=""></r-label>
            <div class="field has-addons">
              <p class="control is-expanded">
                <v-input
                  id="ref"
                  name="ref"
                  @input="lot.created_price_ttc = $event"
                  :model="lot.created_price_ttc"
                  :number="true"
                  :disabled="true"
                  :three-space="true"
                  :errors-bag="errors"
                  v-validate="'required|min:2|max:20'"
                  data-vv-value-path="val"
                  data-vv-as="Prix de création du lot">
                </v-input>
              </p>
              <div class="control">
                <a class="button is-static is-border is-square"><b class="">€&nbsp;TTC</b></a>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <r-label
              label="Loyer marché"
              :value="lot.rent"
              :red-check="hasCheck"
              :is-required="false"></r-label>
            <div class="control">
              <v-input
                :has-addons="true"
                id="rent"
                name="rent"
                @input="lot.rent = $event"
                :model="lot.rent"
                input-type="number"
                :number="true"
                :three-space="true"
                v-validate="'decimal:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Loyer HC">
                <p
                  class="control"
                  slot="addonRight">
                  <a class="button is-static is-square is-border">
                    <span class="icon"><i class="fas fa-euro-sign"></i></span>
                  </a>
                </p>
              </v-input>
            </div>
          </div>
          <div class="column is-6">
            <r-label
              label="Rentabilité marché"
              :is-required="false"></r-label>
            <div class="control">
              <v-input
                :has-addons="true"
                id="profitability"
                name="profitability"
                :disabled="true"
                :model="profitability"
                input-type="number"
                :number="true"
                v-validate="'required|decimal:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Rentabilité marché">
                <p
                  class="control"
                  slot="addonRight">
                  <a class="button is-static is-square is-border">
                    <span class="icon"><i class="fas fa-percentage"></i></span>
                  </a>
                </p>
              </v-input>
            </div>
          </div>
          <div class="column is-6">
            <r-label
              label="Loyer Plafonné"
              :is-required="false"></r-label>
            <div class="control">
              <v-input
                :has-addons="true"
                id="capped_rent"
                name="capped_rent"
                @input="lot.capped_rent = $event"
                :model="lot.capped_rent"
                input-type="number"
                :number="true"
                :three-space="true"
                v-validate="'decimal:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Loyer Plafonné">
                <p
                  class="control"
                  slot="addonRight">
                  <a class="button is-static is-square is-border">
                    <span class="icon"><i class="fas fa-euro-sign"></i></span>
                  </a>
                </p>
              </v-input>
            </div>
          </div>
          <div class="column is-6">
            <r-label
              label="Rentabilité Plafonnée"
              :is-required="false"></r-label>
            <div class="control">
              <v-input
                :has-addons="true"
                id="capped_profitability"
                name="capped_profitability"
                :disabled="true"
                :model="cappedProfitability"
                input-type="number"
                :three-space="true"
                :number="true"
                v-validate="'required|decimal:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Rentabilité Plafonnée">
                <p
                  class="control"
                  slot="addonRight">
                  <a class="button is-static is-square is-border">
                    <span class="icon"><i class="fas fa-percentage"></i></span>
                  </a>
                </p>
              </v-input>
            </div>
          </div>
          <div class="column is-6">
            <r-label
              label="Bonus"
              :is-required="false"
              :truncate="false">
              <span
                class="is-padding-left-xsmall"
                v-helper.right="'7yDv5lwF0SZ5Q4DaXZVwQW'">
                <i class="fal fa-info-circle"></i>
              </span>
            </r-label>
            <div class="control">
              <v-input
                :has-addons="true"
                id="bonus"
                name="bonus"
                @input="lot.bonus = $event"
                :model="lot.bonus"
                input-type="number"
                :number="true"
                :min="0"
                :max="100"
                v-validate="'decimal:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Bonus">
                <p
                  class="control"
                  slot="addonRight">
                  <a class="button is-static is-square is-border">
                    <span class="icon"><i class="fas fa-percentage"></i></span>
                  </a>
                </p>
              </v-input>
            </div>
          </div>
        </div>
      </div>
      <div class="has-background-light">
        <template v-for="(pack, i) in lot.pack_list">
          <lot-pack
            :pack="pack"
            :key="i"
            :idx="i"
            @removePack="removePack(pack, $event)"></lot-pack>
        </template>
        <div class="is-border-top is-border-bottom is-padding has-background-white-bis">
          <a
            @click="addPack"
            class="button is-primary is-padding-right-large is-padding-left-large">Ajouter un prix packagé</a>
        </div>
      </div>
      <div
        v-if="lot.nature === 'field'"
        class="columns is-multiline has-background-light is-marginless is-padding-xsmall">
        <div
          class="column is-4">
          <r-label
            label="Caution dégradations"
            :is-required="false"
            :value="lot.degradation_deposit"></r-label>
          <div class="control">
            <v-input
              :has-addons="true"
              id="degradation_deposit"
              name="degradation_deposit"
              @click="selectedInput = 'ht'"
              @input="updateValue($event, 'degradation_deposit')"
              :model="lot.degradation_deposit"
              input-type="number"
              :three-space="true"
              v-validate="'decimal:2'"
              :errors-bag="errors"
              data-vv-value-path="val"
              :number="true"
              data-vv-as="Caution dégradations">
              <p
                class="control"
                slot="addonRight">
                <a class="button is-static is-border">
                  <span class="icon"><i class="fas fa-euro-sign"></i></span>
                </a>
              </p>
            </v-input>
          </div>
        </div>
        <div
          class="column is-4">
          <r-label
            label="Autre caution"
            :is-required="false"
            :value="lot.other_degradation_deposit"></r-label>
          <div class="control">
            <v-input
              :has-addons="true"
              id="other_degradation_deposit"
              name="other_degradation_deposit"
              @click="selectedInput = 'ht'"
              @input="updateValue($event, 'other_degradation_deposit')"
              :model="lot.other_degradation_deposit"
              input-type="number"
              :three-space="true"
              v-validate="'decimal:2'"
              :errors-bag="errors"
              data-vv-value-path="val"
              :number="true"
              data-vv-as="Autre caution">
              <p
                class="control"
                slot="addonRight">
                <a class="button is-static is-border">
                  <span class="icon"><i class="fas fa-euro-sign"></i></span>
                </a>
              </p>
            </v-input>
          </div>
        </div>
        <div
          class="column is-4">
          <r-label
            label="Caution conformité"
            :is-required="false"
            :value="lot.fences_realisation"></r-label>
          <div class="control">
            <v-input
              :has-addons="true"
              id="fences_realisation"
              name="fences_realisation"
              @click="selectedInput = 'ht'"
              @input="updateValue($event, 'fences_realisation')"
              :model="lot.fences_realisation"
              input-type="number"
              :three-space="true"
              v-validate="'decimal:2'"
              :errors-bag="errors"
              data-vv-value-path="val"
              :number="true"
              data-vv-as="Caution conformité">
              <p
                class="control"
                slot="addonRight">
                <a class="button is-static is-border">
                  <span class="icon"><i class="fas fa-euro-sign"></i></span>
                </a>
              </p>
            </v-input>
          </div>
        </div>
        <div
          class="column is-4">
          <r-label
            label="Installation compteur Eau"
            :is-required="false"
            :value="lot.suez_installation"></r-label>
          <div class="control">
            <v-input
              :has-addons="true"
              id="suez_installation"
              name="suez_installation"
              @click="selectedInput = 'ht'"
              @input="updateValue($event, 'suez_installation')"
              :model="lot.suez_installation"
              input-type="number"
              :three-space="true"
              v-validate="'decimal:2'"
              :errors-bag="errors"
              data-vv-value-path="val"
              :number="true"
              data-vv-as="Installation compteur Eau">
              <p
                class="control"
                slot="addonRight">
                <a class="button is-static is-border">
                  <span class="icon"><i class="fas fa-euro-sign"></i></span>
                </a>
              </p>
            </v-input>
          </div>
        </div>
        <div
          class="column is-4">
          <date-picker
            :model="lot.pc_depose_date"
            :is-required="hasCheck"
            :red-check="hasCheck"
            :style-version="2"
            @input="lot.pc_depose_date = $event"
            label="Date butoir de dépôt PC"></date-picker>
        </div>
      </div>
      <div class="has-background-white is-border-top is-padding">
        <div class="title is-5 is-uppercase">
          <b>Annexes</b>
        </div>
      </div>
      <div
        v-if="!validAnnexes"
        class="notification is-padding-top-xsmall is-padding-bottom-xsmall is-padding-left is-padding-right is-warning">
        <div class="columns is-gapless is-vcentered">
          <div class="column is-narrow is-margin-right">
            <span class="icon"><i class="fa-lg fas fa-engine-warning "></i></span>
          </div>
          <div class="column">
            Une annexe doit impérativement avoir un type défini.
          </div>
        </div>
      </div>
      <div class="is-padding-left is-padding-right is-padding-bottom">
        <div
          v-for="(annex, i) in lot.annex_list"
          :key="i"
          class="is-padding-bottom-xsmall">
          <lot-annex-item
            :source="annex"
            @removeAnnex="removeAnnex(annex, i)"></lot-annex-item>
        </div>
        <div>
          <a
            @click="addAnnex"
            class="button is-primary is-padding-right-large is-padding-left-large"><span>Ajouter une annexe</span>
          </a>
        </div>
      </div>
      <div v-if="lot.nature !== 'parking'">
        <div class="has-background-white is-border-top is-padding">
          <div class="title is-5 is-uppercase">
            <b>Stationnement</b>
          </div>
        </div>
        <div
          v-if="!validParkings"
          class="notification is-warning is-padding-top-xsmall is-padding-bottom-xsmall is-padding-left is-padding-right">
          <div class="columns is-gapless is-vcentered">
            <div class="column is-narrow is-margin-right">
              <span class="icon"><i class="fa-lg fas fa-engine-warning "></i></span>
            </div>
            <div class="column">
              Vous devez obligatoirement déclarer une caractéristique pour chaque parking.<br>
              Elle peuvent être identiques, auquel cas utilisez le même tag de qualification.<br>
              Vous devez également indiquer un PRIX HT et TTC (zéro si gratuit).<br>
            </div>
          </div>
        </div>
        <div class="is-padding-left is-padding-right is-padding-bottom has-background-white">
          <div
            v-for="(parking, i) in lot.parkings"
            :key="i"
            class="is-padding-bottom-xsmall">
            <lot-parking-item
              :source="parking"
              :index="i"
              @removeParking="removeParking(parking, i)"></lot-parking-item>
          </div>
          <div>
            <a
              @click="addParking"
              class="button is-primary is-padding-right-large is-padding-left-large">
              &nbsp;<span>Ajouter un parking</span>
            </a>
          </div>
        </div>
      </div>
      <!-- Mobilier -->
      <div>
        <div class="has-background-white is-border-top is-padding">
          <div class="title is-5 is-uppercase">
            <b>Mobilier</b>
          </div>
        </div>
        <!-- <div
          v-if="!validFurniture"
          class="notification is-warning is-padding-top-xsmall is-padding-bottom-xsmall is-padding-left is-padding-right">
          <div class="columns is-gapless is-vcentered">
            <div class="column is-narrow is-margin-right">
              <span class="icon"><i class="fa-lg fas fa-engine-warning "></i></span>
            </div>
            <div class="column">
              Vous devez obligatoirement déclarer une caractéristique pour chaque parking.<br>
              Elle peuvent être identiques, auquel cas utilisez le même tag de qualification.<br>
              Vous devez également indiquer un PRIX HT et TTC (zéro si gratuit).<br>
            </div>
          </div>
        </div> -->
        <div class="is-padding-left is-padding-right is-padding-bottom has-background-white">
          <div
            v-for="(furniture, i) in lot.furnitures"
            :key="i"
            class="is-padding-bottom-xsmall">
            <lot-furniture-item
              :source="furniture"
              @removeFurniture="removeFurniture(furniture, i)"></lot-furniture-item>
          </div>
          <div>
            <a
              @click="addFurniture"
              class="button is-primary is-padding-right-large is-padding-left-large">
              &nbsp;<span>Ajouter un mobilier</span>
            </a>
          </div>
        </div>
      </div>
      <!-- Notaire -->
      <div>
        <div class="has-background-white is-border-top is-padding">
          <div class="title is-5 is-uppercase">
            <b>Notaire</b>
          </div>
        </div>
        <div class="column columns is-column is-gapless is-space-around is-marginless is-padding-left is-padding-bottom-xlarge">
          <r-label
            :is-required="false"
            :value="specificNotary"></r-label>
          <div>
            <input
              id="specificNotary"
              type="checkbox"
              name="specificNotary"
              class="switch is-success is-success is-rounded is-large"
              v-model="specificNotary">
            <label
              for="specificNotary"
              class="is-paddingless-top">
              <span
                v-if="!specificNotary"
                class="is-size-6 is-padding-top-xsmall">Notaire de l'opération</span>
              <span
                v-else
                class="is-size-6 is-padding-top-xsmall">Notaire spécifique</span>
            </label>
          </div>
        </div>
        <div
          v-if="specificNotary"
          class="is-padding">
          <div
            class="columns is-multiline">
            <div class="column is-6">
              <r-label
                :label="lot.notary_data.tiers_id ? 'Notaire du référentiel' : 'Rechercher un notaire au référentiel'"
                :is-required="false"
                :value="lot.notary_data.tiers_id" />
              <tiers-selector
                :selected="selectedNotaire"
                :slot-ref="lot.notary_data"
                :types="['notaire']"
                placeholder="Nom, ville..."
                @select="selectNotaire"
                @unlink="unlinkNotaire" />
            </div>
            <div class="column is-6"></div>
            <div class="column is-6">
              <r-label
                label="Nom du notaire"
                :is-required="true"
                :red-check="hasCheck"
                :value="lot.notary_data.name"></r-label>
              <div class="control">
                <v-input
                  id="lot.notary_data.name"
                  :disabled="!!lot.notary_data.tiers_id"
                  name="lot.notary_data.name"
                  @input="updateValue($event, 'notary_data', 'name')"
                  :model="lot.notary_data.name"
                  v-validate="'min:2'"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  classes="input"
                  data-vv-as="Nom du notaire">
                </v-input>
              </div>
            </div>
            <div class="column is-6">
              <r-label
                label="Téléphone du notaire"
                :is-required="true"
                :red-check="hasCheck"
                :value="lot.notary_data.phone"
                :truncate="false">
                <span
                  class="is-padding-left-xsmall"
                  v-helper.right="'6BNfgrh0uP7V5UyMRsZvQp'">
                  <i class="fal fa-info-circle"></i>
                </span>
              </r-label>
              <div class="control">
                <v-input
                  id="lot.notary_data.phone"
                  :disabled="!!lot.notary_data.tiers_id"
                  name="lot.notary_data.phone"
                  @input="updateValue($event, 'notary_data', 'phone')"
                  :model="lot.notary_data.phone"
                  input-type="number"
                  v-validate="'min:10'"
                  :placeholder="'06xxxxxxxx / +336xxxxxxxx'"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  data-vv-as="Téléphone"
                  :has-addons="true">
                  <p
                    class="control"
                    slot="addonLeft">
                    <a class="button is-static is-square is-static">
                      <span class="icon"><i class="fas fa-phone-office"></i></span>
                    </a>
                  </p>
                </v-input>
              </div>
            </div>
            <div class="column is-6">
              <r-label
                label="Email"
                :value="lot.notary_data.email"
                :is-required="false"></r-label>
              <div class="control">
                <v-input
                  :has-addons="true"
                  id="lot.notary_data.email"
                  :disabled="!!lot.notary_data.tiers_id"
                  name="lot.notary_data.email"
                  @input="updateValue($event, 'notary_data', 'email')"
                  :model="lot.notary_data.email"
                  v-validate="'email'"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  data-vv-as="Email">
                  <p
                    class="control"
                    slot="addonLeft">
                    <a class="button is-static is-square is-static">
                      <span class="icon"><i class="fas fa-paper-plane"></i></span>
                    </a>
                  </p>
                </v-input>
              </div>
            </div>
            <div class="column is-12">
              <address-input
                v-if="!lot.notary_data.tiers_id"
                label="Adresse de correspondance"
                :source="lot.notary_data.address"
                :is-required="true"
                :red-check="hasCheck"
                @update="updateAddress($event, 'notary_data.address')">
              </address-input>
              <div
                v-else
                class="columns is-multiline">
                <div class="column is-6">
                  <r-label
                    label="Adresse de correspondance"
                    :is-required="false"
                    :value="tiersAddressResume(lot.notary_data.address)" />
                  <input
                    :value="tiersAddressResume(lot.notary_data.address)"
                    type="text"
                    class="input"
                    disabled>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="lotFormTab === 'DOCS'">
      <div class="has-background-white is-padding">
        <div class="title is-5">
          <b class="is-uppercase">Plan du lot</b>
          <span
            class="is-padding-left-xsmall"
            v-helper.bottom="'4KFS6RMsZXkFpEYgFDzsuZ'">
            <i class="fal fa-info-circle"></i>
          </span>
        </div>
        <div>
          <upload-file
            :custom-id="'plan'"
            :source-documents="lot.plan ? [lot.plan] : []"
            :unique="true"
            @upload="uploadDocument({ files: $event, target: 'plan' })"
            @deleteDocument="deleteDocument({ target: 'plan', unique: true })"></upload-file>
        </div>
      </div>
      <div class="has-background-light is-padding">
        <div class="title is-5">
          <b class="is-uppercase">Documents</b>
          <span
            class="is-padding-left-xsmall"
            v-helper.bottom="'Zkzotf83I4r2ecwDnBy7Y'">
            <i class="fal fa-info-circle"></i>
          </span>
        </div>
        <tabs
          :links="documentsTabs"
          :level="1"
          :current-tab="documentsTab"
          classes="has-background-light"
          mode="emitter"
          @changeView="documentsTab = $event"
          :is-fullwidth="true"></tabs>
        <div class="is-padding-top">
          <upload-file
            :multiple="true"
            :custom-id="'documents'"
            :placeholder="'Sélectionner document(s)'"
            :source-documents="documentsToDisplay"
            :has-destination="true"
            :destinations-list="lotDestinations"
            :hide-upload="documentsTab !== 'DOCUMENTS'"
            @upload="uploadDocument({ files: $event })"
            @deleteDocument="deleteDocument({ document: $event })"></upload-file>
        </div>
      </div>
    </div>
    <div v-show="lotFormTab === 'PARAMS'">
      <!-- Switch visbibility -->
      <div class="is-padding has-background-white--darken1">
        <div class="columns">
          <div class="column is-4 columns is-column is-gapless is-space-between is-marginless">
            <div class="control">
              <input
                id="intern_visibility"
                name="intern_visibility"
                type="checkbox"
                class="switch is-success is-rounded"
                v-model="lot.intern_visibility">
              <label
                for="intern_visibility"
                class="is-uppercase">
                <span
                  v-if="internVisible"
                  class="is-size-6 is-margin-top-xxsmall">Lots visibles vendeur(s) interne
                </span>
                <span
                  v-else
                  class="is-size-6 is-margin-top-xxsmall">Lots masqués vendeur(s) interne
                </span>
              </label>
            </div>
          </div>
          <div class="column is-4 columns is-column is-gapless is-space-between is-marginless">
            <div class="control">
              <input
                id="extern_visibility"
                name="extern_visibility"
                type="checkbox"
                class="switch is-success is-rounded"
                v-model="lot.extern_visibility">
              <label
                for="extern_visibility"
                class="is-uppercase">
                <span
                  v-if="externVisible"
                  class="is-size-6 is-margin-top-xxsmall">Lots visibles prescripteur(s)
                </span>
                <span
                  v-else
                  class="is-size-6 is-margin-top-xxsmall">Lots masqués prescripteur(s)
                </span>
              </label>
            </div>
          </div>
          <div class="column is-4 columns is-column is-gapless is-space-between is-marginless">
            <div class="control">
              <input
                id="lot_site_enable"
                name="lot_site_enable"
                type="checkbox"
                class="switch is-success is-rounded"
                v-model="lot.lot_site_enable">
              <label
                for="lot_site_enable"
                class="is-uppercase">
                <span
                  v-if="lot.lot_site_enable"
                  class="is-size-6 is-margin-top-xxsmall">Lot visible sur site public
                </span>
                <span
                  v-else
                  class="is-size-6 is-margin-top-xxsmall">Lot masqué sur site public
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="has-background-white is-padding">
        <div>
          <r-label
            label="Statut d'édition du lot"
            :is-required="false"></r-label>
          <div class="columns is-gapless is-multiline has-cloud-checkradiocase">
            <div
              class="column is-3 has-background-white"
              v-for="s in availableLotStatusList"
              :key="'lotStatus-' + s.value">
              <input
                v-model="lot.status"
                :value="s.value"
                :disabled="!isAdmin"
                :name="'lotStatus'"
                :id="'lotStatus-' + s.value"
                type="radio"
                class="vadCheckradiocase is-fullwidth">
              <label :for="'lotStatus-'+s.value">{{ s.label }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <submit-sticky-buttons
      @submit="submit"
      :loading="submitLoading"
      button-id="lotForm"></submit-sticky-buttons>
  </form>
</template>

<script>
import LotMixin from './LotMixin'
import { cloneDeep } from 'lodash'
import TiersLink from '@/components/tiers/TiersLinkMixin'

const emptyPackagePrice = ({
  name: '',
  description: null,
  sale_price_ttc: 0,
  sale_price_ht: 0
})
const emptyAnnex = ({
  annex_type: '',
  surface: null,
  info: null
})
const emptyParking = ({
  lot_pk: null,
  nature: null,
  ref: null,
  info: null,
  floor: null,
  sale_price_ht: 0,
  sale_price_ttc: 0,
  parking_type: [],
  sales_mode: [],
  tva: 20
})
const emptyFurniture = ({
  ref: null,
  sale_price_ht: 0,
  sale_price_ttc: 0,
  info: null,
  tva: 20
})

export default {
  name: 'LotForm',
  components: {
    LotPack: () => import('./LotPack'),
    LotAnnexItem: () => import('./LotAnnexItem'),
    LotParkingItem: () => import('./LotParkingItem'),
    LotFurnitureItem: () => import('./LotFurnitureItem'),
    TiersSelector: () => import('@/components/tiers/TiersSelector')
  },
  filters: {
    tvaLabelRounded (value) {
      if (value.toString().split('.').length === 1) {
        return `${value}.0`
      } else {
        return value
      }
    }
  },
  mixins: [LotMixin, TiersLink],
  data () {
    return {
      selectedNotaire: null,
      specificNotary: false,
      formMode: true,
      lotFormTab: 'FICHE_LOT',
      annexesToDelete: [],
      packsToDelete: [],
      parkingsToDelete: [],
      furnituresToDelete: [],
      tvaList: [20, 10, 7, 5.5, 0, 'autre'],
      getTva: null
    }
  },
  computed: {
    tva () {
      return Number((this.p.sale_price_ttc - this.p.sale_price_ht) * 100 / this.p.sale_price_ht).toFixed(2)
      // return Number((this.lot.sale_price_ttc - this.lot.sale_price_ht) / this.lot.sale_price_ht * 100).toFixed(2)
    },
    lotFormTabsLinks () {
      return [
        { link: 'FICHE_LOT', label: 'Fiche du lot' },
        { link: 'DOCS', label: 'Documents', disable: this.newLot },
        { link: 'PARAMS', label: 'Paramètres', disable: this.newLot }
      ]
    },
    validAnnexes () {
      if (this.lot && this.lot.annex_list && this.lot.annex_list.length) {
        return !this.lot.annex_list.find(x => !x.annex_type)
      }
      return true
    },
    validParkings () {
      if (this.lot && this.lot.parkings && this.lot.parkings.length) {
        return !this.lot.parkings.find(x => {
          return !x.parking_type || x.sale_price_ttc === '' || x.sale_price_ttc == null || x.sale_price_ttc < 0 || x.sale_price_ht === '' || x.sale_price_ht == null || x.sale_price_ht < 0
        })
      }
      return true
    },
    validFurniture () {
      if (this.lot && this.lot.furnitures && this.lot.furnitures.length) {
        return !this.lot.furnitures.find(x => {
          return !x.ref || x.sale_price_ttc === '' || x.sale_price_ttc == null || x.sale_price_ttc < 0 || x.sale_price_ht === '' || x.sale_price_ht == null || x.sale_price_ht < 0
        })
      }
      return true
    },
    cappedProfitability () {
      let parkingPrice = 0
      if (this.lot && this.lot.parkings) {
        parkingPrice = this.lot.parkings.reduce((a, b) => {
          return a + Number(b.sale_price_ttc)
        }, 0)
      }
      if (!(this.lot.sale_price_ttc - parkingPrice)) return 0
      return (Number(this.lot.capped_rent) * 12 / (Number(this.lot.sale_price_ttc) - Number(parkingPrice)) * 100).toFixed(2)
    },
    profitability () {
      return (this.lot.rent * 12 / this.lot.sale_price_ttc * 100).toFixed(2)
    },
    filteredNaturesList () {
      return this.naturesList.filter(x => !x.hide)
    },
    filteredTypesList () {
      return this.typesList.filter((x) => x.show.includes(this.lot.nature))
    },
    filteredSubtypesList () {
      return this.subtypesList.filter((x) => x.show.includes(this.lot.nature))
    },
    filteredTypesTaxList () {
      return this.typesTaxList.filter((x) => x.show.includes('lot'))
    },
    filteredNbFaceList () {
      return this.nbfaceList.filter(x => !x.hide)
    },
    filteredSalesModeList () {
      return this.salesmodeList.filter(x => !x.hide)
    },
    programBuildings () {
      return this.lotProgram ? this.lotProgram.buildings : []
    },
    buildingsByTranche () {
      let result = []
      if (this.lotProgram && this.lotProgram.use_tranche && this.lotProgram.tranches && this.lotProgram.tranches.length) {
        this.lotProgram.tranches.forEach(tranche => {
          let trancheObj = {}
          trancheObj.name = tranche.name
          trancheObj.pk = tranche.pk
          trancheObj.buildings = []
          this.lotProgram.buildings.forEach(building => {
            if (tranche.pk === building.tranche) {
              trancheObj.buildings.push(building)
            }
          })
          result.push(trancheObj)
        })
      }
      return result
    },
    internVisible () {
      return this.lot.intern_visibility
    },
    externVisible () {
      return this.lot.extern_visibility
    }
  },
  watch: {
    specificNotary (val) {
      if (!val) {
        this.lot.notary_data.name = null
        this.lot.notary_data.phone = null
        this.lot.notary_data.address = null
        this.lot.notary_data.email = null
        this.$set(this.lot.notary_data, 'tiers_id', null)
        this.$set(this.lot.notary_data, 'interlocuteur_id', null)
        this.selectedNotaire = null
      }
    },
    sourceLotProgram (v) {
      if (v) this.updateSources({ program: v })
    },
    'lot.ref' (to, from) {
      if (!this.formMode) return
      if (!to || !from) return
      let previousVal = from
      this.lot.ref = to
      if (this.lot.ref !== previousVal && to.length >= 2) {
        this.verifyAvaibilityLotRef(to)
      }
    },
    'lot.nature' (to, from) {
      if (from && from !== to) {
        this.lot.lot_type = null
        this.lot.lot_subtype = []
        this.lot.nb_face = null
      }
    },
    'lot.tva_on_marge' () {
      if (this.lot.tva_on_marge === false) {
        this.lot.tva_reduce = false
      }
    }
  },
  created () {
    if (this.$route.query && this.$route.query.panel) {
      this.lotFormTab = this.$route.query.panel
    }
  },
  updated () {
    if (this.lot.notary_data.name && this.lot.notary_data.phone && this.lot.notary_data.address) this.specificNotary = true
  },
  methods: {
    /**
       * Use that method for non assignment or dom update issue (for red check for exemple)
       * @param { any } value - new value to assign
       * @param { String } key - primary key in program object
       * @param { String } secondaryKey - for deep assignment, key in program[key] object
       */
    updateValue (value, key, secondaryKey) {
      if (secondaryKey) {
        this.$set(this.lot[key], secondaryKey, value)
      } else {
        this.$set(this.lot, key, value)
      }
    },
    /**
       * Sélection d'un notaire du référentiel : lie et remplit les champs
       * @param {object} interlocuteur - { ...interlocuteur, tiers }
       */
    selectNotaire (interlocuteur) {
      this.selectedNotaire = interlocuteur
      this.applyTiersSelection(this.writeNotaire, interlocuteur)
    },
    /**
       * Délier du référentiel : vide aussi les champs (anti-doublon)
       */
    unlinkNotaire () {
      this.selectedNotaire = null
      this.applyTiersUnlink(this.writeNotaire)
    },
    /**
       * writer(key, value) du bloc notaire spécifique
       */
    writeNotaire (key, value) {
      this.updateValue(value, 'notary_data', key)
    },
    updateAddress (address, target = 'address') {
      let t = target.split('.')
      if (t.length > 1) {
        this.$set(this.lot[t[0]], t[1], address)
      } else {
        this.$set(this.lot, t[0], address)
      }
    },
    initLotForm (lot) {
      if (lot.tax_dispositifs && lot.tax_dispositifs.length) {
        this.lot.tax_dispositifs = lot.tax_dispositifs.map(x => this.taxDispositifsList.find(y => y.value === x))
      }
      if (lot.sales_mode && lot.sales_mode.length) {
        this.lot.sales_mode = lot.sales_mode.map(x => this.filteredSalesModeList.find(y => y.value === x))
      }
      if (lot.building) {
        this.lot.building = lot.building.pk
        this.lot.tranche = lot.building.tranche
      }
    },
    duplicateLotForm (lot) {
      lot.pk = null
      lot.ref = null
      lot.status = 'draft'
      lot.plan = null
      lot.documents = []
      lot.program = lot.program.pk
      lot.promoteur = lot.promoteur.pk
      if (lot.annex_list && lot.annex_list.length) {
        lot.annex_list.forEach(x => {
          x.pk = null
        })
      }
      if (lot.pack_list && lot.pack_list.length) {
        lot.pack_list.forEach(x => {
          x.pk = null
        })
      }
      if (lot.parkings && lot.parkings.length) {
        lot.parkings.forEach(x => {
          x.pk = null
        })
      }
    },
    async submit () {
      if (!this.validAnnexes) {
        this.$toasted.global.danger('Veuillez renseigner les champs annexes')
        return
      }

      if (!this.validParkings) {
        this.$toasted.global.danger('Veuillez renseigner les champs parkings')
        return
      }

      if (!this.validFurniture) {
        this.$toasted.global.danger('Veuillez renseigner les champs mobilier')
        return
      }

      if (this.specificNotary && (!this.lot.notary_data.address || !this.lot.notary_data.name || !this.lot.notary_data.phone)) {
        this.$toasted.global.danger('Veuillez renseigner les champs notaire')
        return
      }
      const lot = await this.beforeSubmitLot(this.lot)

      this.$emit('submit', lot)
      if (!this.newLot) {
        this.submitLotCharacteristics()
      }
    },
    submitLotCharacteristics () {
      // process all Characteristics
      // Annexes
      this.annexesToDelete.forEach((annex, i) => this.removeAnnex(annex, i, true))
      this.lot.annex_list.forEach((annex, i) => !annex.pk ? this.addAnnex(annex, i, true) : null)
      this.lot.annex_list.forEach((annex, i) => annex.pk ? this.saveAnnex(annex) : null)
      // Packs
      this.packsToDelete.forEach((pack, i) => this.removePack(pack, i, true))
      this.lot.pack_list.forEach((pack, i) => !pack.pk ? this.addPack(pack, i, true) : null)
      this.lot.pack_list.forEach((pack, i) => pack.pk ? this.savePack(pack) : null)
      // Parkings
      this.parkingsToDelete.forEach((parking, i) => this.removeParking(parking, i, true))
      this.lot.parkings.forEach((parking, i) => !parking.pk ? this.addParking(parking, i, true) : null)
      this.lot.parkings.forEach((parking, i) => parking.pk ? this.saveParking(parking) : null)
      // Furnitures
      this.furnituresToDelete.forEach((furniture, i) => this.removeFurniture(furniture, i, true))
      this.lot.furnitures.forEach((furniture, i) => !furniture.pk ? this.addFurniture(furniture, i, true) : null)
      this.lot.furnitures.forEach((furniture, i) => furniture.pk ? this.saveFurniture(furniture) : null)
    },
    async addPack (pack, idx, submit = false) {
      if (submit) {
        try {
          const { data } = await this.$api.post(this.$resources.LOT_PACK(this.lot.pk), pack)
          this.lot.pack_list.splice(idx, 1, data)
        } catch (e) {
          console.log(e)
        }
      } else {
        this.lot.pack_list.push({ ...cloneDeep(emptyPackagePrice), sale_price_ttc: null, sale_price_ht: null })
      }
    },
    async removePack (pack, idx, submit = false) {
      if (submit) {
        try {
          await this.$api.delete(this.$resources.LOT_PACK(this.lot.pk), pack.pk)
        } catch (e) {
          console.log(e)
        }
      } else {
        this.lot.pack_list.splice(idx, 1)
        this.packsToDelete.push(pack)
      }
    },
    async savePack (pack) {
      try {
        await this.$api.put(this.$resources.LOT_PACK(this.lot.pk), pack.pk, pack)
      } catch (e) {
        console.log(e)
      }
    },
    async addAnnex (annex, idx, submit = false) {
      if (submit) {
        try {
          const { data } = await this.$api.post(this.$resources.LOT_ANNEX(this.lot.pk), annex)
          this.lot.annex_list.splice(idx, 1, data)
        } catch (err) {
          console.log(err)
        }
      } else {
        this.lot.annex_list.push({ ...cloneDeep(emptyAnnex) })
      }
    },
    async removeAnnex (annex, idx, submit = false) {
      if (submit) {
        try {
          await this.$api.delete(this.$resources.LOT_ANNEX(this.lot.pk), annex.pk)
        } catch (e) {
          console.log(e)
        }
      } else {
        this.lot.annex_list.splice(idx, 1)
        this.annexesToDelete.push(annex)
      }
    },
    async saveAnnex (annex) {
      try {
        await this.$api.put(this.$resources.LOT_ANNEX(this.lot.pk), annex.pk, annex)
      } catch (e) {
        console.log(e)
      }
    },
    async addParking (parking, idx, submit = false) {
      if (submit) {
        try {
          const { data } = await this.$api.post(this.$resources.LOT_PARKING(this.lot.pk), parking)
          this.lot.parkings.splice(idx, 1, data)
        } catch (e) {
          console.log(e)
        }
      } else {
        this.lot.parkings.push({ ...cloneDeep(emptyParking), ref: `${this.lot.ref} - ${this.lot.parkings.length + 1}` })
      }
    },
    async removeParking (parking, idx, submit = false) {
      if (submit) {
        try {
          await this.$api.delete(this.$resources.LOT_PARKING(this.lot.pk), parking.pk)
        } catch (e) {
          console.log(e)
        }
      } else {
        this.lot.parkings.splice(idx, 1)
        this.parkingsToDelete.push(parking)
      }
    },
    async saveParking (parking) {
      try {
        await this.$api.put(this.$resources.LOT_PARKING(this.lot.pk), parking.pk, parking)
      } catch (e) {
        console.log(e)
      }
    },
    async addFurniture (furniture, idx, submit = false) {
      if (submit) {
        try {
          const { data } = await this.$api.post(this.$resources.LOT_FURNITURE(this.lot.pk), furniture)
          this.lot.furnitures.splice(idx, 1, data)
        } catch (e) {
          console.log(e)
        }
      } else {
        this.lot.furnitures.push({ ...cloneDeep(emptyFurniture) })
      }
    },
    async removeFurniture (furniture, idx, submit = false) {
      if (submit) {
        try {
          await this.$api.delete(this.$resources.LOT_FURNITURE(this.lot.pk), furniture.pk)
        } catch (e) {
          console.log(e)
        }
      } else {
        this.lot.furnitures.splice(idx, 1)
        this.furnituresToDelete.push(furniture)
      }
    },
    async saveFurniture (furniture) {
      try {
        await this.$api.put(this.$resources.LOT_FURNITURE(this.lot.pk), furniture.pk, furniture)
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
